import MultipleChoice from './fields/MultiChoice';

export const permissionsConfig = [
  {
    component: MultipleChoice,
    dictionary: 'countries',
    name: 'permission.countries',
    title: 'Countries',
  },
  {
    component: MultipleChoice,
    dictionary: 'departments',
    name: 'permission.departments',
    title: 'Departments',
  },
  {
    component: MultipleChoice,
    dictionary: 'seniorities',
    name: 'permission.seniorities',
    title: 'Seniority',
  },
  {
    component: MultipleChoice,
    dictionary: 'teams',
    name: 'permission.teams',
    title: 'Teams',
  },
  {
    component: MultipleChoice,
    dictionary: 'titles',
    name: 'permission.titles',
    title: 'Titles',
  },
  {
    component: MultipleChoice,
    dictionary: 'workplaces',
    name: 'permission.workplaces',
    title: 'Workplaces',
  },
];
